// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.permissions-terms-page {
  width: 100%;
  min-height: 100vh;
  background: #121212;
  color: #f1f1f1;
  font-family: "Satoshi", sans-serif;
}

.permissions-terms-section {
  width: 100%;
  padding: clamp(60px, 8vw, 120px) 24px clamp(80px, 10vw, 96px);
  max-width: 800px;
  margin: 0 auto;
}

.permissions-terms-title {
  text-align: center;
  font-size: clamp(32px, 4vw, 44px);
  font-weight: 600;
  margin: 0 0 24px;
  color: #f1f1f1;
  line-height: 1.25;
}

.permissions-terms-intro {
  text-align: center;
  font-size: clamp(15px, 1.5vw, 17px);
  line-height: 1.6;
  color: #a0a0a0;
  margin: 0 0 48px;
}

.permissions-terms-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.permissions-terms-block {
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px 28px;
  transition: border-color 0.2s ease;
}

.permissions-terms-block:hover {
  border-color: rgba(255, 255, 255, 0.16);
}

.permissions-terms-heading {
  font-size: clamp(18px, 1.8vw, 20px);
  font-weight: 600;
  color: #ccff00;
  margin: 0 0 12px;
  line-height: 1.3;
}

.permissions-terms-block p {
  font-size: clamp(14px, 1.2vw, 16px);
  line-height: 1.65;
  color: #a0a0a0;
  margin: 0 0 12px;
}

.permissions-terms-block p:last-child {
  margin-bottom: 0;
}

.permissions-terms-block ul {
  list-style: none;
  margin: 12px 0 0;
  padding: 0;
}

.permissions-terms-block li {
  position: relative;
  padding-left: 20px;
  margin-bottom: 8px;
  font-size: clamp(14px, 1.2vw, 16px);
  line-height: 1.6;
  color: #a0a0a0;
}

.permissions-terms-block li::before {
  content: "•";
  position: absolute;
  left: 0;
  color: #ccff00;
  font-weight: 700;
}

.permissions-terms-block li:last-child {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/permissions-terms-privacy/permissions-terms-privacy.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".permissions-terms-page {\n  width: 100%;\n  min-height: 100vh;\n  background: #121212;\n  color: #f1f1f1;\n  font-family: \"Satoshi\", sans-serif;\n}\n\n.permissions-terms-section {\n  width: 100%;\n  padding: clamp(60px, 8vw, 120px) 24px clamp(80px, 10vw, 96px);\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.permissions-terms-title {\n  text-align: center;\n  font-size: clamp(32px, 4vw, 44px);\n  font-weight: 600;\n  margin: 0 0 24px;\n  color: #f1f1f1;\n  line-height: 1.25;\n}\n\n.permissions-terms-intro {\n  text-align: center;\n  font-size: clamp(15px, 1.5vw, 17px);\n  line-height: 1.6;\n  color: #a0a0a0;\n  margin: 0 0 48px;\n}\n\n.permissions-terms-content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.permissions-terms-block {\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 24px 28px;\n  transition: border-color 0.2s ease;\n}\n\n.permissions-terms-block:hover {\n  border-color: rgba(255, 255, 255, 0.16);\n}\n\n.permissions-terms-heading {\n  font-size: clamp(18px, 1.8vw, 20px);\n  font-weight: 600;\n  color: #ccff00;\n  margin: 0 0 12px;\n  line-height: 1.3;\n}\n\n.permissions-terms-block p {\n  font-size: clamp(14px, 1.2vw, 16px);\n  line-height: 1.65;\n  color: #a0a0a0;\n  margin: 0 0 12px;\n}\n\n.permissions-terms-block p:last-child {\n  margin-bottom: 0;\n}\n\n.permissions-terms-block ul {\n  list-style: none;\n  margin: 12px 0 0;\n  padding: 0;\n}\n\n.permissions-terms-block li {\n  position: relative;\n  padding-left: 20px;\n  margin-bottom: 8px;\n  font-size: clamp(14px, 1.2vw, 16px);\n  line-height: 1.6;\n  color: #a0a0a0;\n}\n\n.permissions-terms-block li::before {\n  content: \"•\";\n  position: absolute;\n  left: 0;\n  color: #ccff00;\n  font-weight: 700;\n}\n\n.permissions-terms-block li:last-child {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
